import React from 'react'

import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { ConfirmationCodeInput as DesignSystemConfirmationCodeInput, FieldLabel } from '@cash-design-system/react'
import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-feature-flags'

import { getConfirmationCodeFormat } from '../util'
import { FieldController } from './FieldController/FieldController'
import { FormMaskedInput } from './FormMaskedInput'

interface Props {
  showLabel?: boolean
}

const InnerConfirmationCodeInput: React.FC<Props> = ({ showLabel = true }) => {
  const { t } = useTranslation()
  const { watch } = useFormContext()
  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('apps')

  const watchCode = watch('code') || ''
  const codeFormat = getConfirmationCodeFormat(watchCode)

  if (isArcadeMigrationEnabled) {
    return (
      <FieldController
        FieldComponent={DesignSystemConfirmationCodeInput}
        componentProps={{
          autoFocus: true,
          maxDigits: 12,
          placeholder: t('Code', { context: 'placeholder text for form field asking for confirmation code' }),
        }}
        name="code"
        rules={{
          required: {
            value: true,
            message: t('Enter a confirmation code.', {
              context: 'error message for not entering a confirmation code',
            }),
          },
        }}
      />
    )
  }

  return (
    <FormMaskedInput
      autoFocus
      name="code"
      placeholder={t('Code', { context: 'placeholder text for form field asking for confirmation code' })}
      format={codeFormat}
      rules={{
        required: {
          value: true,
          message: t('Enter a confirmation code.', { context: 'error message for not entering a confirmation code' }),
        },
      }}
    />
  )
}
export function ConfirmationCodeInput({ showLabel = true }: Props): React.ReactElement {
  const { t } = useTranslation()

  if (showLabel) {
    return (
      <FieldLabel label={t('Confirmation code', { context: 'label for form field asking for confirmation code' })}>
        <InnerConfirmationCodeInput />
      </FieldLabel>
    )
  }

  return <InnerConfirmationCodeInput />
}
